module.exports = __webpack_public_path__ + "static/media/acacia-mall-interior-02-mobile.1bcd4464.webp";